import React from 'react';
import './About.css';
import aboutImage from '../../assets/images/about-image.jpg';
import teamImage from '../../assets/images/team.jpg';
import facilityImage from '../../assets/images/facility.jpg';

const About = () => {
  return (
    <main className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1>About Our Training Center</h1>
          <p>Providing exceptional healthcare education since 2025</p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="container">
          <div className="mission-content">
            <div className="mission-text">
              <h2>Our Mission</h2>
              <p>
                To empower students with the knowledge, skills, and confidence needed 
                to excel in the healthcare field through comprehensive, state-approved 
                training programs.
              </p>
              <div className="mission-stats">
                <div className="stat">
                  <span className="stat-number">50+</span>
                  <span className="stat-label">Graduates</span>
                </div>
                <div className="stat">
                  <span className="stat-number">98%</span>
                  <span className="stat-label">Pass Rate</span>
                </div>
                <div className="stat">
                  <span className="stat-number">85%</span>
                  <span className="stat-label">Job Placement</span>
                </div>
              </div>
            </div>
            <div className="mission-image">
              <img src={aboutImage} alt="Students learning" />
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section">
        <div className="container">
          <h2>Our Expert Instructors</h2>
          <p className="section-subtitle">
            Learn from healthcare professionals with real-world experience
          </p>
          <div className="team-grid">

            <div className="team-member">
              <div className="member-image">
                <img src={teamImage} alt="Instructor" />
              </div>
              <h3>Susan Njire</h3>
              <p className="position">Program Director</p>
              <p className="bio">
                30+ years of nursing experience with specialization in geriatric care
              </p>
            </div>
            {/* Add more team members */}
          </div>
        </div>
      </section>

      {/* Facilities Section */}
      <section className="facilities-section">
        <div className="container">
          <h2>Our Facilities</h2>
          <div className="facility-showcase">
            <img src={facilityImage} alt="Training facility" />
            <div className="facility-features">
              <h3>State-of-the-Art Learning Environment</h3>
              <ul>
                <li>Modern simulation labs</li>
                <li>Fully equipped classrooms</li>
                <li>Hands-on training equipment</li>
                <li>Comfortable student lounge</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;